import { render, staticRenderFns } from "./CostManager.vue?vue&type=template&id=1b635cae&scoped=true"
import script from "./CostManager.vue?vue&type=script&lang=ts"
export * from "./CostManager.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b635cae",
  null
  
)

export default component.exports